import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Button,
  CircularProgress,
  Typography,
  FormLabel,
  Stack,
  Switch,
  FormControlLabel,
  Grid,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  fetchDonationReportByBookNo,
  fetchDonationReportByBookNoPayModeAll,
  fetchDonationReportByBookNoPayModeWise,
  fetchDonationReportByDonorWise,
  fetchDonationReportByDonorWiseBookReceiptNo,
  fetchDonationReportByDonorWiseBookNo,
  fetchDonationReportByPayPurpose,
} from "../../../redux/reportDonationSlice";
import { fetchDropdownOptions } from "../../../redux/dropdownoptionsSlice";
import DonationReportTable from "./DonationReportTable";
import { logger } from "../../../utils/logger";

import { fetchReportFormat } from "../../../redux/reportSettingsSlice";


// const DonationRepotFilter = () => {
//   const [category, setCategory] = useState("");
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");
//   const [tableType, setTableType] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filterApplied, setFilterApplied] = useState(false);
//   const dispatch = useDispatch();
//   const [addPayMode, setAddPayMode] = useState(false);
//   const [payMode, setPayMode] = useState("All");
//   const [fromdate, setFromdate] = useState(null);
//   const [todate, setTodate] = useState(null);
//   const [bookNo, setBookNo] = useState("");
//   const [receiptNo, setReceiptNo] = useState("");
//   const { data = {} } = useSelector((state) => state.dropdownOptions);
//   const { user, role } = useSelector((state) => state.auth);

//   useEffect(() => {
//     if (!data.paymode.length) {
//       dispatch(fetchDropdownOptions("paymode"));
//     }
//   }, [dispatch, data.paymode.length]);

//   const handleFilter = async () => {
//     try {
//       setLoading(true);
//       setFilterApplied(false);
//       setTableData([]);
//       if (category === "Bookwise" && from && to && !addPayMode) {
//         const response = await dispatch(
//           fetchDonationReportByBookNo({ from, to })
//         );
//         const payload = response?.payload;
//         if (Array.isArray(payload?.report) && payload.report.length > 0) {
//           setTableData(payload);
//           setTableType("bookwise");
//           logger.info("Filter applied successfully", {
//             filterType: "Donation Report-Bookwise",
//             username: user?.username,
//             role: role,
//           });
//         } else {
//           setTableData([]);
//           logger.warn("Filter applied but no data found", {
//             filterType: "Donation Report-Bookwise",
//             username: user,
//             role: role,
//           });
//         }
//       } else if (
//         category === "Bookwise" &&
//         from &&
//         to &&
//         addPayMode &&
//         payMode === "All"
//       ) {
//         const response = await dispatch(
//           fetchDonationReportByBookNoPayModeAll({ from, to })
//         );
//         const payload = response?.payload;
//         if (Array.isArray(payload?.report) && payload.report.length > 0) {
//           setTableData(payload);
//           setTableType("bookwise-paymodeall");
//           logger.info("Filter applied successfully", {
//             filterType: "Donation Report-Bookwise PayMode All",
//             username: user?.username,
//             role: role,
//           });
//         } else {
//           setTableData([]);
//           logger.warn("Filter applied but no data found", {
//             filterType: "Donation Report-Bookwise PayMode All",
//             username: user?.username,
//             role: role,
//           });
//         }
//       } else if (
//         category === "Bookwise" &&
//         from &&
//         to &&
//         addPayMode &&
//         payMode !== "All"
//       ) {
//         const response = await dispatch(
//           fetchDonationReportByBookNoPayModeWise({ from, to, payMode })
//         );
//         const payload = response?.payload;
//         if (Array.isArray(payload?.report) && payload.report.length > 0) {
//           setTableData(payload);
//           setTableType("bookwise-paymodewise");
//           logger.info("Filter applied successfully", {
//             filterType: "Donation Report-Bookwise Paymode wise",
//             payMode: payMode,
//             username: user?.username,
//             role: role,
//           });
//         } else {
//           setTableData([]);
//           logger.warn("Filter applied but no data found", {
//             filterType: "Donation Report-Bookwise PayMode wise",
//             username: user?.username,
//             role: role,
//           });
//         }
//       }
const DonationRepotFilter = () => {
  const [category, setCategory] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [year, setYear] = useState(""); // NEW: "" = all years, else Format 2 filter
  const [tableType, setTableType] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const dispatch = useDispatch();
  const [addPayMode, setAddPayMode] = useState(false);
  const [payMode, setPayMode] = useState("All");
  const [fromdate, setFromdate] = useState(null);
  const [todate, setTodate] = useState(null);
  const [bookNo, setBookNo] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const { data = {} } = useSelector((state) => state.dropdownOptions);
  const { user, role } = useSelector((state) => state.auth);
  const { format: reportFormat, minYear } = useSelector((state) => state.reportSettings);

  // NEW: year dropdown options — current year down to 2000
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - minYear + 1 },
    (_, i) => currentYear - i
  );

  useEffect(() => {
    if (!data.paymode.length) {
      dispatch(fetchDropdownOptions("paymode"));
    }
  }, [dispatch, data.paymode.length]);
  useEffect(() => {
  dispatch(fetchReportFormat());
}, [dispatch]);

  const handleFilter = async () => {
    try {
      setLoading(true);
      setFilterApplied(false);
      setTableData([]);
      if (category === "Bookwise" && from && to && !addPayMode) {
        const response = await dispatch(
          fetchDonationReportByBookNo({ from, to, year })
        );
        const payload = response?.payload;
        if (Array.isArray(payload?.report) && payload.report.length > 0) {
          setTableData(payload);
          setTableType("bookwise");
          logger.info("Filter applied successfully", {
            filterType: "Donation Report-Bookwise",
            year: year || "All",
            username: user?.username,
            role: role,
          });
        } else {
          setTableData([]);
          logger.warn("Filter applied but no data found", {
            filterType: "Donation Report-Bookwise",
            username: user,
            role: role,
          });
        }
      } else if (
        category === "Bookwise" &&
        from &&
        to &&
        addPayMode &&
        payMode === "All"
      ) {
        const response = await dispatch(
          fetchDonationReportByBookNoPayModeAll({ from, to, year })
        );
        const payload = response?.payload;
        if (Array.isArray(payload?.report) && payload.report.length > 0) {
          setTableData(payload);
          setTableType("bookwise-paymodeall");
          logger.info("Filter applied successfully", {
            filterType: "Donation Report-Bookwise PayMode All",
            year: year || "All",
            username: user?.username,
            role: role,
          });
        } else {
          setTableData([]);
          logger.warn("Filter applied but no data found", {
            filterType: "Donation Report-Bookwise PayMode All",
            username: user?.username,
            role: role,
          });
        }
      } else if (
        category === "Bookwise" &&
        from &&
        to &&
        addPayMode &&
        payMode !== "All"
      ) {
        const response = await dispatch(
          fetchDonationReportByBookNoPayModeWise({ from, to, payMode, year })
        );
        const payload = response?.payload;
        if (Array.isArray(payload?.report) && payload.report.length > 0) {
          setTableData(payload);
          setTableType("bookwise-paymodewise");
          logger.info("Filter applied successfully", {
            filterType: "Donation Report-Bookwise Paymode wise",
            payMode: payMode,
            year: year || "All",
            username: user?.username,
            role: role,
          });
        } else {
          setTableData([]);
          logger.warn("Filter applied but no data found", {
            filterType: "Donation Report-Bookwise PayMode wise",
            username: user?.username,
            role: role,
          });
        }
      }

      

      if (category === "FundWise") {
        const response = await dispatch(
          fetchDonationReportByPayPurpose(payMode)
        );
        const payload = response?.payload;
        if (Array.isArray(payload?.report) && payload.report.length > 0) {
          setTableData(payload);
          setTableType("fundwise");
          logger.info("Filter applied successfully", {
            filterType: "Donation Report - Fundwise",
            payMode: payMode,
            username: user?.username,
            role: role,
          });
        } else {
          setTableData([]);
          logger.warn("Filter applied but no data found", {
            filterType: "Donation Report - Fundwise",
            payMode: payMode,
            username: user?.username,
            role: role,
          });
        }
      }
      if (category === "DonorWise") {
        if (fromdate && todate && !bookNo && !receiptNo) {
          const response = await dispatch(
            fetchDonationReportByDonorWise({ fromdate, todate })
          );
          const payload = response?.payload;
          if (Array.isArray(payload?.report) && payload.report.length > 0) {
            setTableData(payload);
            setTableType("donorwise");
            logger.info("Filter applied successfully", {
              filterType: "Donation Report-Donorwise(From/To Date)",
              from: fromdate,
              to: todate,
              username: user?.username,
              role: role,
            });
          } else {
            setTableData([]);
            logger.warn("Filter applied but no data found", {
              filterType: "Donation Report-Donorwise(From/To Date)",
              from: fromdate,
              to: todate,
              username: user?.username,
              role: role,
            });
          }
        } else if (fromdate && todate && bookNo && receiptNo) {
          const response = await dispatch(
            fetchDonationReportByDonorWiseBookReceiptNo({
              fromdate,
              todate,
              bookNo,
              receiptNo,
            })
          );
          const payload = response?.payload;
          if (Array.isArray(payload?.report) && payload.report.length > 0) {
            setTableData(payload);
            setTableType("donorwise");
            logger.info("Filter applied successfully", {
              filterType:
                "Donation Report-Donorwise(From/To Date & Book /Receipt No)",
              from: fromdate,
              to: todate,
              bookNo: bookNo,
              receiptNo: receiptNo,
              username: user?.username,
              role: role,
            });
          } else {
            setTableData([]);
            logger.warn("Filter applied but no data found", {
              filterType:
                "Donation Report-Donorwise(From/To Date & Book /Receipt No)",
              from: fromdate,
              to: todate,
              bookNo: bookNo,
              receiptNo: receiptNo,
              username: user?.username,
              role: role,
            });
          }
        } else if (fromdate && todate && bookNo && !receiptNo) {
          const response = await dispatch(
            fetchDonationReportByDonorWiseBookNo({
              fromdate,
              todate,
              bookNo,
            })
          );
          const payload = response?.payload;
          if (Array.isArray(payload?.report) && payload.report.length > 0) {
            setTableData(payload);
            setTableType("donorwise");
            logger.info("Filter applied successfully", {
              filterType: "Donation Report-Donorwise(From/To Date & Book No)",
              from: fromdate,
              to: todate,
              bookNo: bookNo,
              username: user?.username,
              role: role,
            });
          } else {
            setTableData([]);
            logger.warn("Filter applied but no data found", {
              filterType: "Donation Report-Donorwise(From/To Date & Book No)",
              from: fromdate,
              to: todate,
              bookNo: bookNo,
              username: user?.username,
              role: role,
            });
          }
        }
      }
    } catch (err) {
      logger.error("Error occur during  donation filter applied", { error: err });
      console.error("Error fetching report:", err);
      setTableData([]);
    } finally {
      setLoading(false);
      setFilterApplied(true);
    }
  };

  return (
    <>
      <Box 
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          marginBottom: 2,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Category</InputLabel>
          <Select
            label="Category"
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <MenuItem value="DonorWise">DonorWise</MenuItem>
            <MenuItem value="FundWise">FundWise</MenuItem>
            <MenuItem value="Bookwise">Bookwise</MenuItem>
          </Select>
        </FormControl>

        {category === "DonorWise" && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* From Date */}
            <DatePicker
              label="From Date"
              value={fromdate}
              onChange={(newValue) => setFromdate(newValue)}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              slotProps={{
                textField: {
                  readOnly: true,
                  size: "small",
                  fullWidth: true,
                },
              }}
              sx={{ maxWidth: 150 }}
            />

            {/* To Date */}
            <DatePicker
              label="To Date"
              value={todate}
              onChange={(newValue) => setTodate(newValue)}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              slotProps={{
                textField: {
                  readOnly: true,
                  size: "small",
                  fullWidth: true,
                },
              }}
              sx={{ maxWidth: 150 }}
            />

            {/* Book No */}
            <TextField
              label="Book No"
              value={bookNo}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(value)) {
                  setBookNo(value);
                }
              }}
              fullWidth
              size="small"
              sx={{ maxWidth: 150 }}
            />

            {/* Receipt No */}
            <TextField
              label="Receipt No"
              value={receiptNo}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9]*$/.test(value)) {
                  setReceiptNo(value);
                }
              }}
              fullWidth
              size="small"
              sx={{ maxWidth: 150 }}
            />
          </LocalizationProvider>
        )}

        {category === "FundWise" && (
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Pay Mode</InputLabel>
            <Select
              label="Pay Mode"
              name="payMode"
              value={payMode}
              onChange={(e) => setPayMode(e.target.value)}
            >
              {(data.paymode || []).map((opt) => (
                <MenuItem key={opt._id} value={opt.value}>
                  {opt.value}
                </MenuItem>
              ))}
              <MenuItem value="All">All</MenuItem>
            </Select>
          </FormControl>
        )}

        {category === "Bookwise" && (
  <>
    <TextField
      label="From Book No"
      value={from}
      onChange={(e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9]*$/.test(value)) {
          setFrom(value);
        }
      }}
      size="small"
    />
    <TextField
      label="To Book No"
      value={to}
      onChange={(e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9]*$/.test(value)) {
          setTo(value);
        }
      }}
      size="small"
    />

    {/* NEW: Year filter — optional */}
   {reportFormat === "yearFilter" && (
  <FormControl size="small" sx={{ minWidth: 130 }}>
    <InputLabel>Year</InputLabel>
    <Select
      label="Year"
      value={year}
      onChange={(e) => setYear(e.target.value)}
    >
      <MenuItem value="">All Years</MenuItem>
      {yearOptions.map((y) => (
        <MenuItem key={y} value={y}>
          {y}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)}

    <FormControl
      component="fieldset"
      size="small"
      sx={{ minWidth: 120, pl: 1 }}
    >
      <FormLabel component="legend">Add Pay Mode</FormLabel>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography>No</Typography>
        <Switch
          label="Add Pay Mode"
          name="addPayMode"
          value={addPayMode}
          sx={{ marginTop: 3 }}
          onChange={(e) => setAddPayMode(e.target.checked)}
        />
        <Typography>Yes</Typography>
      </Stack>
    </FormControl>
    {addPayMode ? (
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Pay Mode</InputLabel>
        <Select
          label="Pay Mode"
          name="payMode"
          value={payMode}
          onChange={(e) => setPayMode(e.target.value)}
        >
          {(data.paymode || []).map((opt) => (
            <MenuItem key={opt._id} value={opt.value}>
              {opt.value}
            </MenuItem>
          ))}
          <MenuItem value="All">All</MenuItem>
        </Select>
      </FormControl>
    ) : null}
  </>
)}

        <Button variant="contained" color="primary" onClick={handleFilter}>
          Apply Filter
        </Button>
      </Box>

      {loading ? (
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(tableData.report) && tableData.report.length > 0 ? (
        <DonationReportTable data={tableData} type={tableType} reportFormat={reportFormat} />
      ) : filterApplied ? (
        <Box textAlign="center" mt={2} fontWeight="bold" color="black">
          No reports found
        </Box>
      ) : null}
    </>
  );
};

export default DonationRepotFilter;
